<template>
  <section v-if="dormant" class="bg-white rounded-xl border border-gray-100 shadow-sm p-5 md:p-6">
    <div class="tw-flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-900 m-0">Dormant users</h3>
    </div>
    <p class="text-sm text-gray-500 mt-0 mb-3">
      Previously active members who have not done anything for a while — candidates for re-engagement.
    </p>

    <div class="grid gap-4 sm:grid-cols-3 mb-4">
      <div class="rounded-lg border border-gray-100 bg-gray-50 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 m-0 mb-1">Inactive 30+ days</p>
        <p class="text-2xl font-semibold text-gray-900 m-0">{{ dormant.d30 }}</p>
      </div>
      <div class="rounded-lg border border-gray-100 bg-gray-50 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 m-0 mb-1">Inactive 60+ days</p>
        <p class="text-2xl font-semibold text-gray-900 m-0">{{ dormant.d60 }}</p>
      </div>
      <div class="rounded-lg border border-gray-100 bg-gray-50 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 m-0 mb-1">Inactive 90+ days</p>
        <p class="text-2xl font-semibold text-gray-900 m-0">{{ dormant.d90 }}</p>
      </div>
    </div>

    <!--    <div v-if="list.length">
          <h4 class="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">Longest inactive</h4>
          <div class="overflow-x-auto">
            <table class="w-full text-sm border-collapse">
              <thead>
              <tr class="border-b border-gray-200 text-left text-xs font-semibold uppercase tracking-wide text-gray-400">
                <th class="py-2 pr-4 font-semibold">Member</th>
                <th class="py-2 font-semibold">Last active</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="user in list" :key="user.id" class="border-b border-gray-100 hover:bg-gray-50">
                <td class="py-2 pr-4 text-gray-700">{{ user.name }}</td>
                <td class="py-2 text-gray-500">{{ formatDate(user.last_activity) }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>-->
  </section>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'HeartbeatDormantUsers',
    props: {
      activity: Object,
    },
    computed: {
      dormant () {
        return this.activity && this.activity.dormant
      },
      list () {
        return (this.dormant && this.dormant.list) || []
      },
    },
    methods: {
      formatDate (value) {
        if (!value) {
          return '—'
        }

        const date = moment(value)
        return date.format('D MMM YYYY') + ' (' + date.fromNow() + ')'
      },
    },
  }
</script>
